class AboutNav extends HTMLElement {
  constructor() {
    super();
    this.links = Array.from(this.querySelectorAll('.about-nav__link[data-target]'));
    this.targets = this.links
      .map((link) => document.getElementById(link.dataset.target))
      .filter(Boolean);

    if (this.targets.length === 0) return;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '-45% 0px -50% 0px',
      threshold: 0,
    });

    this.targets.forEach((target) => this.observer.observe(target));
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      this.links.forEach((link) => {
        link.classList.toggle('is-active', link.dataset.target === entry.target.id);
      });
    });
  }
}

customElements.define('about-nav', AboutNav);
